export const MAP_SETTINGS_READY_SET = 'MAP_SETTINGS_READY/SET';
